import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./blogPageStyles.css";
import { useNavigate } from 'react-router-dom';

const PregnancyDietPlan = () => {
  const navigate = useNavigate(); 
  return (
    <>
      <Header />
       <div style={{
          padding: '30px', width: '100%', background: '#fff', paddingTop: "100px" }}>
           <button
             style={{
               marginTop: '20px',
               padding: '0px 20px',
               fontSize: '20px', 
               fontWeight: "bolder",
               backgroundColor: '#2196f3',
               color: '#fff',
               border: 'none',
               borderRadius: '8px',
               cursor: 'pointer',
             }}
             onClick={() => navigate('/blogs')} 
           >
             ⬅
           </button>
          <div className='fullContenth1'>
          <h1>Pregnancy Diet Plan: What to Eat & Avoid During Pregnancy</h1>
            <img
            src="/Blog4.png" 
            alt="First Trimester"
            style={{
              width: '600px',
              maxHeight: '700px',
              objectFit: 'cover',
              borderRadius: '12px',
              margin: '20px auto',
              display: 'block',
            }}
          />
          </div>

          <h2 className='fullContenth2'>Pregnancy Diet Plan: What to Eat and Avoid</h2>
          <p className='fullContentp'>Being pregnant is a divine duty, encompassing a process of building a human being, cell by cell, organ by
                                     organ. And what's most essential in the development of the baby? The food you consume. Every food
                                     option you choose for yourself helps your baby grow and develop their brain, bones, immunity, and even
                                     their taste buds. Your body is building another human – and food is the raw material.</p>
          <p className='fullContentp'>Yet many expecting mothers either just follow a regular diet, viral diet plans available on the internet, or
                                     eat casually following their cravings, believing it’s “just nine months.” Well, due to this, mothers-to-be
                                     are relying on poor or mismatched nutrition that further silently harms both mother and baby. That’s
                                     why pregnancy nutrition isn’t optional — it’s necessary and foundational.</p>

          <h2 className='fullContenth2'>How Diet Directly Affects Your Baby’s Development</h2>
          <p className='fullContentp'>From the very first week, your baby relies on your body for nourishment. The impact of diet goes far
                                      beyond hunger or cravings — it’s about life and development.</p>
          <p className='fullContentp'>If your body lacks essential nutrients, your baby may face:</p>
          <ul className='fullContentlist'>
            <li>● Low birth weight</li>
            <li>● Developmental delays (brain, spine, organs)</li>
            <li>● Increased risk of preterm labor</li>
            <li>● Weakened immunity or poor bone formation</li>
            <li>● Higher chance of complications like gestational diabetes or anemia in the mother</li>
          </ul>
          <p className='fullContentp'>According to experts, deficiencies in essential nutrients like iron and folic acid during pregnancy can have
                                      a direct and serious impact on fetal development, potentially leading to impaired brain growth or spinal
                                      defects in the baby. If you skip key nutrients, your baby skips key milestones.</p>
          <h2 className='fullContenth2'>Why a Personalized Diet Plan Is Not Optional?</h2>
          <p className='fullContentp'> No two pregnancies are the same, and neither are the women experiencing them. Each woman has a
                                        unique nutrient absorption capacity, body composition, pre-pregnancy health status, appetite, and
                                        lifestyle. That’s why generic pregnancy diets often fall short—and in some cases, may even do more
                                        harm than good. A personalized pregnancy diet plan is essential to ensure trimester-specific and
                                        mom-specific calorie intake, the right balance of macronutrients (proteins, fats, and carbohydrates), and
                                        adequate levels of critical nutrients like iron, folic acid, calcium, vitamin D, and omega-3s. Experts also
                                        warn that silent nutritional deficiencies—such as vitamin B12 or zinc—can go unnoticed until
                                        complications arise later in pregnancy. Don’t wait for symptoms to appear; a tailored approach is key to a
                                        healthy pregnancy.</p>
          <h2 className='fullContenth2'>What to Eat During Pregnancy: Trimester-Wise Breakdown</h2>
          <h2 className='fullContenth3'>First Trimester (0–13 Weeks) </h2>
          <p className='fullContentp'>In the early weeks of pregnancy, your body undergoes rapid hormonal changes, often leading to nausea,
                                       fatigue, and a reduced appetite. So, when choosing foods to eat when pregnant first trimester, the
                                       focus should be on nausea-friendly, easily digestible foods and staying hydrated.</p>
          <p className='fullContentp'>What is included in the first trimester diet plan is Dry snacks like crackers, lemon water, bananas, small,
                                      frequent meals, and folate-rich foods such as spinach, lentils, and oranges.</p>
          <p className='fullContentp'>Key nutrients: Folic acid (for neural tube development), vitamin B6 (to ease nausea), and iron (to support
                                     increased blood volume).</p>
          <h2 className='fullContenth3'>Second Trimester (14–26 Weeks) </h2>
           <p className='fullContentp'>This is the phase of rapid fetal growth, where nutritional demands increase to support organ
                                       development, muscle formation, and bone strength.</p>
           <p className='fullContentp'>What to eat: Incorporate protein-rich foods (chicken, tofu, legumes), dairy (milk, cheese), leafy greens,
                                       fruits, nuts, and eggs into your meals.</p>
           <p className='fullContentp'>Key nutrients: Protein (for tissue growth), calcium and vitamin D (for bone development), iron (to
                                       prevent anemia), and omega-3 fatty acids (for brain development).</p>
 
           <h2 className='fullContenth3'>Third Trimester (27 Weeks to Delivery) </h2>
           <p className='fullContentp'>As the baby puts on weight and prepares for birth, your energy needs peak. This is also the time to
                                       prepare your body for labor.</p>
           <p className='fullContentp'>What to eat: Focus on complex carbohydrates (whole grains, sweet potatoes), lentils, fiber-rich fruits and
                                       vegetables, and healthy fats like avocado and nuts.</p>
           <p className='fullContentp'>Key nutrients: Iron (for oxygen transport), protein (for continued growth), magnesium (for muscle
                                     relaxation), and zinc (to support immune function and healing).</p>
           <p className='fullContentp'>Eating mindfully through each trimester ensures your baby gets the right nutrients at the right
                                      time—and helps you stay strong and energized throughout your pregnancy.</p>
                                      
          <h2 className='fullContenth2'>Foods to Avoid During Pregnancy</h2>
          <p className='fullContentp'>Be mindful — certain foods need to be avoided during pregnancy as they can pose real risks:</p>
           <ul className='fullContentlist'>
             <li>● Raw eggs, unpasteurized milk, or soft cheeses → Risk of infection</li>
             <li>● High-mercury fish (shark, swordfish, king mackerel) → Harms a baby’s brain</li>
             <li>● Raw or unripe papaya and pineapple are some of the vital foods to avoid in the first month of
                   pregnancy → Can trigger contractions</li>
             <li>● Screens for health risks and recommends safe lifestyle adjustments</li>
             <li>● Junk food, sodas, packaged chips → Leads to poor fetal growth and maternal fatigue</li>
           </ul>
          <h2 className='fullContenth2'>Healthy Daily Food Staples (General Indian Diet Suggestions)</h2>
          <p className='fullContentp'>Here is the list suggesting healthy foods for pregnancy:</p>
           <ul className='fullContentlist'>
             <li>● Whole wheat roti or rice</li>
             <li>● Moong dal, sabzi, khichdi</li>
             <li>● Seasonal fruits: apple, guava, banana, pomegranate</li>
             <li>● Curd, buttermilk, and ghee in moderation</li>
             <li>● Coconut water, soaked almonds, or walnuts are vital foods to eat in the first trimester</li>
             <li>● Warm water and natural fluids (jeera or ajwain water)</li>
           </ul>
           <p className='fullContentp'>Did you know? Your baby’s taste buds are developing in the womb. The food you eat — garlic, mangoes,
                                      even mild spices — shapes their preferences.</p>
          <p className='fullContentp'>Myprega moms often find babies accept solids more easily when variety was part of their prenatal diet.</p>
          <h2 className='fullContenth2'>Mental Health and Nutrition: A Two-Way Connection</h2>
          <p className='fullContentp'>Nutrition doesn’t just affect your body — it influences your mind, too. Poor meals or skipped nutrition</p>
          <p className='fullContentp'>can cause:</p>
           <ul className='fullContentlist'>
             <li>Mood swings, anxiety, and brain fog</li>
             <li>Fatigue, irritability, and stress</li>
           </ul>
          <p className='fullContentp'>Nutrients like magnesium, iron, omega-3, and B-complex play a direct role in stabilizing mood.
                                     That’s why Myprega includes mental health guidance in your pregnancy plan, mentioning foods to eat
                                     during pregnancy, because food and feelings go hand in hand.</p>
          
          <h2 className='fullContenth2'>Diet Integration Is Mandatory — Not Optional</h2>
          <p className='fullContentp'>Pregnancy isn’t something you can navigate on autopilot or manage solely through monthly checkups.
                                      baby is growing every single day, and your diet plays a critical, daily role in that development. Diet is
                                      ally a daily medicine for your pregnancy. Think of food as your most powerful and consistent form of
                                      ine during these nine months.</p>
          <ul className='fullContentlist'>
            <li>1. When thoughtfully planned, your diet does more than just nourish — it</li>
            <li>2. Builds your baby’s brain and vital organs</li>
            <li>3. Prepares your body for a smooth and healthy delivery</li>
            <li>4. Maintains stable energy levels to fight fatigue</li>
            <li>5. Supports emotional well-being and hormonal balance</li>
          </ul>
          <p className='fullContentp'>Here’s a serious reminder: a poor first trimester diet or any trimester diet today can lead to
                                       complications at birth or developmental concerns later. This isn’t fearmongering — it’s a fact backed by
                                       science. Your daily nutrition choices are building blocks for a healthy pregnancy and a healthy baby.
                                       Personalized, trimester-wise diet is the difference between a struggling mom and a healthy, happy mom.</p>
            <h2 className='fullContenth2'>Final Message: Make Every Day Nutrition-Filled </h2>
            <p className='fullContentp'>Pregnancy is personal, and your care should be too. It’s not about eating more, but eating right for you,
                                        and hence, now you have a food list for pregnancy. Every bite is a building block of your baby’s future.</p>  
            <ul className='fullContentlist'>
              <li>Let your meals reflect the love and care you want to give.</li>
              <li>Let your nutrition be intentional.</li>
              <li>And let your journey be guided with support that understands you.</li>
            </ul>
          <p className='fullContentp' style={{alignContent: "center"}}>“Your plate today is your baby’s first classroom.”<br></br>
                            Choose wisely. Choose personally. Choose whole care — the Myprega way.</p>         
          <button
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#2196f3',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            onClick={() => navigate('/blogs')} 
          >
            ← Back to Blogs
          </button>
        </div>
      <Footer />
    </>
  );
};

export default PregnancyDietPlan;

